import { gql } from '@apollo/client';

const getStartWorks = gql`
  query getStartWorks(
    $start: Date
    $end: Date
    $active: Boolean
    $departmentId: String
    $employeeId: String
  ) {
    getStartWorks(
      start: $start
      end: $end
      active: $active
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      data {
        _id
        branch
        autoNo
        docNo
        time
        title
        desc
        contractId
        contractName
        contractNameAr
        departmentId
        departmentName
        departmentNameAr
        employeeId
        employeeName
        employeeNameAr
        bonos
        overtime
        deduction
        isWorking
        isAbsent
        isShift1
        isShift2
        isVacation
        userId
        note
        createdAt
        updatedAt
      }
      message
      count
      error
    }
  }
`;

export default getStartWorks;
